<template>
  <div>
    <base-crud
      crud-name="Jornada de Trabalho"
      new-text="Nova Jornada"
      :table="WorktimeTable"
      :columns="columns"
      :options="options"
      :end-point="endPoint"
      :enable-add="true"
      :enable-edit="true"
      :enable-delete="true"
      :enable-view="false"
      :data-form="dataForm"
    />
  </div>
</template>

<script>
import BaseCrud from '../../layouts/Base/BaseCrud'

export default {
  components: {
    BaseCrud,
  },
  data() {
    return {
      WorktimeTable: 'WorktimeTable',
      Worktimes: [],
      pages: [],
      url: '',
      columns: ['id', 'title', 'started_at', 'ended_at', 'default', 'actions'],
      tableData: [],
      options: {
        filterByColumn: true,
        filterable: ['id', 'title', 'started_at', 'ended_at', 'default'],
        sortable: ['id', 'title', 'started_at', 'ended_at', 'default'],
        pagination: { chunk: 10, dropdown: false, nav: 'scroll' },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: 'ID',
          name: 'Nome',
          started_at: 'Inicia em',
          ended_at: 'Termina em',
          default: 'Padrão',
          actions: 'Ações',
        },
        requestFunction(data) {
          const requestData = {}

          const query = this.$parent.$parent.$parent.query(data.query)
          requestData.params = data
          requestData.params.query = ''
          requestData.params.with = []

          return axios.get(`${this.url}?${query}`, requestData).catch(
            e => {
              this.dispatch('error', e)
            },
          )
        },
        templates: {
          started_at(h, row, index) {
            return new Date(row.started_at).toLocaleDateString()
          },
          ended_at(h, row, index) {
            return new Date(row.ended_at).toLocaleDateString()
          },
          default(h, row, index) {
            return row.default == '1' ? 'Sim' : 'Não'
          },
        },
      },
      endPoint: 'worktimes/',

      dataForm: {
        id: {
          type: 'integer',
        },
      },
    }
  },
  methods: {
    query(query) {
      const columns = {
        id: 'id',
        title: 'title',
        email: 'email',
      }
      let filters = ''
      $.each(query, (index, value) => {
        filters += `${columns[index]}=${value}&`
      })

      return filters
    },
  },
}
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
